import script from "./heder.vue?vue&type=script&setup=true&lang=js"
export * from "./heder.vue?vue&type=script&setup=true&lang=js"

import "./heder.vue?vue&type=style&index=0&id=62ebba3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ebba3e"]])

export default __exports__